import { SVGFC } from '@repo/toolkit/types'

const InstructionIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9520_417966)">
        <path
          d="M16.0637 18.6818V19.3636C16.0637 19.9636 15.5728 20.4545 14.9728 20.4545H4.85458C4.25458 20.4545 3.76367 19.9636 3.76367 19.3636V4.63632C3.76367 4.03632 4.25458 3.54541 4.85458 3.54541H12.9273"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.064 6.62695V10.5815"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9819 3.54541L16.0637 6.62723H13.9637C13.4182 6.62723 12.9546 6.19086 12.9546 5.61814V3.54541H12.9819Z"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1362 16.2267L18.7362 15.8994"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0273 16.9086C14.8909 16.8268 14.7818 16.745 14.6727 16.6632C13.9091 16.0086 12.8182 14.8905 11.9454 14.3723L10.3091 13.3905C10.3909 13.1995 10.5273 13.0359 10.6909 12.9541C10.9364 12.8177 11.2364 12.7905 11.5364 12.8995L12.6545 13.5268L11.1 10.8541C10.9364 10.5541 11.0182 10.1995 11.3182 10.0086C11.6182 9.845 11.9727 9.92682 12.1636 10.2268L13.6909 12.845"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9361 13.3086L13.2816 12.1632C13.118 11.8632 13.1998 11.5086 13.4998 11.3177C13.7998 11.1541 14.1543 11.2359 14.3452 11.5359L14.727 12.1904"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9999 12.6813L14.4544 11.754C14.2908 11.454 14.3726 11.0995 14.6726 10.9085C14.9726 10.7449 15.3272 10.8267 15.5181 11.1267L15.7908 11.5631"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0636 12.0813L15.7909 11.5904C15.6272 11.2904 15.709 10.9359 16.009 10.745C16.309 10.5813 16.6636 10.6631 16.8545 10.9631L18.0272 12.9541C18.2727 13.3631 18.6818 14.345 18.6818 14.8086"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3107 14.4981L14.3979 17.3345L15.3252 18.9406L20.2379 16.1042L19.3107 14.4981Z"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.04541 6.08154H5.64541V8.09973"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.64551 4.99072V5.12709"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95459 5.53613H11.6455"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95459 6.76318H12"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95459 7.99072H14.7546"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 9.21777H10.3638"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 9.21777H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 10.4727H9.60012"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 10.4727H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 11.6997H10.2547"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 11.6997H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 12.9272H9.2183"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 12.9272H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 14.1543H9.2183"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 14.1543H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 15.3818H11.1001"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 15.3818H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0093 16.4727H5.31836V19.009H13.0093V16.4727Z"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0637 18.6818V19.3636C16.0637 19.9636 15.5728 20.4545 14.9728 20.4545H4.85458C4.25458 20.4545 3.76367 19.9636 3.76367 19.3636V4.63632C3.76367 4.03632 4.25458 3.54541 4.85458 3.54541H12.9273"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0635 6.62744V10.582"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9819 3.54541L16.0637 6.62723H13.9637C13.4182 6.62723 12.9546 6.19086 12.9546 5.61814V3.54541H12.9819Z"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1362 16.2272L18.7362 15.8999"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0273 16.9091C14.8909 16.8273 14.7818 16.7455 14.6727 16.6637C13.9091 16.0091 12.8182 14.8909 11.9454 14.3728L10.3091 13.3909C10.3909 13.2 10.5273 13.0364 10.6909 12.9546C10.9364 12.8182 11.2364 12.7909 11.5364 12.9L12.6545 13.5273L11.1 10.8546C10.9364 10.5546 11.0182 10.2 11.3182 10.0091C11.6182 9.84549 11.9727 9.92731 12.1636 10.2273L13.6909 12.8455"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9361 13.3091L13.2816 12.1637C13.118 11.8637 13.1998 11.5091 13.4998 11.3182C13.7998 11.1546 14.1543 11.2364 14.3452 11.5364L14.727 12.1909"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9999 12.6818L14.4544 11.7545C14.2908 11.4545 14.3726 11.0999 14.6726 10.909C14.9726 10.7454 15.3272 10.8272 15.5181 11.1272L15.7908 11.5636"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0636 12.0818L15.7909 11.5909C15.6272 11.2909 15.709 10.9364 16.009 10.7455C16.309 10.5818 16.6636 10.6636 16.8545 10.9636L18.0272 12.9545C18.2727 13.3636 18.6818 14.3455 18.6818 14.8091"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3107 14.4986L14.3979 17.335L15.3252 18.941L20.2379 16.1047L19.3107 14.4986Z"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.04541 6.08154H5.64541V8.09973"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.64551 4.99072V5.12709"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95459 5.53613H11.6455"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95459 6.76318H12"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.95459 7.99072H14.7546"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 9.21777H10.3638"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 9.21777H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 10.4727H9.60012"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 10.4727H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 11.6997H10.2547"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 11.6997H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 12.9272H9.2183"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 12.9272H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 14.1543H9.2183"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 14.1543H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.98193 15.3818H11.1001"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.31836 15.3818H5.89109"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0093 16.4727H5.31836V19.009H13.0093V16.4727Z"
          stroke={color}
          strokeWidth="0.545455"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9520_417966">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InstructionIcon
